export default function ($http) {
    return function (dealerId) {
        return $http.delete(`/api/dealers/${dealerId}`).then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/dealer/services/delete/deleteDealer.js